export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline text-gold-dark mb-6">Our story</div>
      <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight mb-8">A firm built on <span className="italic">patience</span>.</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-10">
        <div>
          <p className="text-midnight/75 leading-relaxed mb-6">Founded in Delhi in 2022, Manigriv Financial Services is a boutique advisory serving families, founders and mid-market corporates. We're SEBI registered, fee-only, and product-agnostic by design.</p>
          <p className="text-midnight/75 leading-relaxed">Our approach is unfashionably slow: we write down every plan, review it quarterly, and refuse to sell what our own families wouldn't own.</p>
        </div>
        <div className="grid grid-cols-2 gap-6">
          {[["Independent","Zero commissions or kickbacks."],["Fiduciary","Client interests come first, in writing."],["Research-first","Every recommendation traceable to a thesis."],["Long-term","We measure success in decades."]].map(([k,v])=>(
            <div key={k} className="p-6 bg-white rounded-xl border border-black/5">
              <div className="overline text-gold-dark mb-2">{k}</div>
              <p className="text-sm text-midnight/75">{v}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-16 rounded-2xl overflow-hidden aspect-[21/9]">
        <img src="https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Office" className="w-full h-full object-cover" />
      </div>
    </div>
  );
}
